// src/app/%28public%29/landing/page.tsx
import { createFileRoute } from '@tanstack/react-router'
import type { Metadata } from "next";
import { EcommerceMetrics } from "@/components/ecommerce/EcommerceMetrics"; 
import MonthlySalesChart from "@/components/ecommerce/MonthlySalesChart"; 

export const metadata: Metadata = {
  title:
    "Next.js E-commerce Dashboard | TailAdmin - Next.js Dashboard Template",
  description: "This is Next.js Home for TailAdmin Dashboard Template",
};

function LandingPage() {
  return (
    <div className="grid grid-cols-12 gap-4 md:gap-6">
      <div className="col-span-12 space-y-6 xl:col-span-7">
        <EcommerceMetrics />

        <MonthlySalesChart />
      </div>

       
    </div>
  );
}

export const Route = createFileRoute('/(public)/landing/')({
  component: LandingPage,
})
